import React, { useState } from "react";
import { withRouter } from "react-router";
import { Modal } from "../../../../../shared/Modal/Modal";
import { Tabs } from "../../../../../shared/Tabs/Tabs";
import classes from "./scss/ClientWalletPatientFi.module.scss";
import PatientFiModalPhoneForm from "./components/PatientFiModalPhoneForm";
import PatientFiModalEmailForm from "./components/PatientFiModalEmailForm";
import { useClientQuery } from "../../../../../api/queries/useClientQuery";

const PatientFiWalletModal = ({ onClose, match }) => {
  const [activeTab, setActiveTab] = useState("newClient");
  const clientId = parseInt(match?.params?.clientID);
  const { data, isLoading } = useClientQuery({ clientId });

  const client = {
    id: clientId,
    email: data?.email || "",
    phone: data?.phone || "",
    isLoading: isLoading,
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      header={<Modal.Title>PatientFi Enroll</Modal.Title>}
      footerNoBorder
    >
      <Tabs
        variant="tiled"
        active={activeTab}
        className={classes.tabs}
        options={[
          {
            label: "New Client",
            value: "newClient",
            onClick: () => setActiveTab("newClient"),
          },
          {
            label: "Existing Borrower",
            value: "existingClient",
            onClick: () => setActiveTab("existingClient"),
          },
        ]}
      />
      {activeTab === "newClient" && (
        <PatientFiModalPhoneForm client={client} onClose={onClose} />
      )}
      {activeTab === "existingClient" && (
        <PatientFiModalEmailForm client={client} onClose={onClose} />
      )}
    </Modal>
  );
};

export default withRouter(PatientFiWalletModal);
